{
  "name": "@ns/public-ledger-credit-extra-charge",
  "version": "1.0.0",
  "description": "A payment intent was paid for a nodeStream credits purchase that had already been paid (#25 DECISION 2.8). The purchase keeps the payment it delivered; the PUBLIC_LEDGER team refunds the extra payment by hand in Stripe, then completes the card with refunded.",
  "inputs": {},
  "outcomes": {
    "refunded": {}
  }
}
